export const SUMMARY_COUNTRY_ATTEMPT = "SUMMARY_COUNTRY_ATTEMPT";
export const SUMMARY_COUNTRY_SUCCESS = "SUMMARY_COUNTRY_SUCCESS";
export const SUMMARY_COUNTRY_FAILED = "SUMMARY_COUNTRY_FAILED";
export const LOGOUT = "LOGOUT";